import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { motion, AnimatePresence } from 'framer-motion';
import { MEAL_TYPE_CONFIG } from './constants';

export const PlanDetailModal = ({ selectedPlan, setSelectedPlan, followPlan }) => {
  return (
    <AnimatePresence>
      {selectedPlan && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 bg-black/90 overflow-y-auto"
          onClick={() => setSelectedPlan(null)}
        >
          <div 
            className="container mx-auto max-w-3xl py-8 px-4"
            onClick={(e) => e.stopPropagation()}
          >
            <motion.div
              initial={{ scale: 0.95 }}
              animate={{ scale: 1 }}
              className="bg-card border border-border"
            >
              {/* Modal Header */}
              <div className="p-6 border-b border-border">
                <div className="flex items-start justify-between">
                  <div>
                    <h3 className="font-heading text-2xl text-white uppercase tracking-wider">
                      {selectedPlan.plan?.name}
                    </h3>
                    <p className="text-muted-foreground mt-1">{selectedPlan.plan?.description}</p>
                  </div>
                  <Button variant="ghost" onClick={() => setSelectedPlan(null)}>
                    Close
                  </Button>
                </div>
              </div>
              
              {/* Modal Content */}
              <div className="p-6 space-y-6">
                {/* Macros */}
                <div className="grid grid-cols-4 gap-4">
                  <div className="bg-white/5 p-3 text-center">
                    <div className="text-xl font-bold text-white">{selectedPlan.plan?.daily_calories}</div>
                    <div className="text-xs text-muted-foreground">Calories</div>
                  </div>
                  <div className="bg-white/5 p-3 text-center">
                    <div className="text-xl font-bold text-white">{selectedPlan.plan?.daily_protein}g</div>
                    <div className="text-xs text-muted-foreground">Protein</div>
                  </div>
                  <div className="bg-white/5 p-3 text-center">
                    <div className="text-xl font-bold text-white">{selectedPlan.plan?.daily_carbs}g</div>
                    <div className="text-xs text-muted-foreground">Carbs</div>
                  </div>
                  <div className="bg-white/5 p-3 text-center">
                    <div className="text-xl font-bold text-white">{selectedPlan.plan?.daily_fat}g</div>
                    <div className="text-xs text-muted-foreground">Fat</div>
                  </div>
                </div>
                
                {/* Sample Meals */}
                <div>
                  <h4 className="font-heading text-lg text-white uppercase tracking-wider mb-4">
                    Sample Meals
                  </h4>
                  <div className="space-y-3">
                    {Object.values(selectedPlan.meals || {}).slice(0, 6).map((meal) => (
                      <div key={meal.id} className="bg-white/5 p-4 flex items-center justify-between">
                        <div>
                          <Badge className={`${MEAL_TYPE_CONFIG[meal.meal_type]?.bg} ${MEAL_TYPE_CONFIG[meal.meal_type]?.color} mb-1`}>
                            {meal.meal_type}
                          </Badge>
                          <h5 className="text-white font-medium">{meal.name}</h5>
                        </div>
                        <div className="text-right">
                          <div className="text-primary font-bold">{meal.calories} cal</div>
                          <div className="text-xs text-muted-foreground">
                            P: {meal.protein}g • C: {meal.carbs}g • F: {meal.fat}g
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                
                {/* Action */}
                {!selectedPlan.user_following && (
                  <Button
                    className="w-full bg-primary text-black hover:bg-primary/90"
                    onClick={() => {
                      followPlan(selectedPlan.plan?.id);
                      setSelectedPlan(null);
                    }}
                  >
                    Start This Plan
                  </Button>
                )}
              </div>
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
